import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=15266759&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15266759",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15266759')) {
      api.createRecord('15266759', component.options)
    } else {
      api.reload('15266759', component.options)
    }
    module.hot.accept("./Datenschutz.vue?vue&type=template&id=15266759&scoped=true", function () {
      api.rerender('15266759', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Datenschutz.vue"
export default component.exports